import { Fab as FabButton, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import GetAppIcon from '@material-ui/icons/GetApp';
import { colors } from '../constants/colors';
import { useCreateLabel } from '../hooks/useCreateLabel';

const useStyles = makeStyles((theme) => ({
    root: {
        // margin: theme.spacing(1),
        backgroundColor: colors.orange,
        color: colors.white,
        textTransform: 'capitalize',
        width: 40,
        minWidth: 40,
        height: 40,
        borderRadius: '50%',
        padding: 0,
        boxShadow: `0px 3px 5px -1px ${colors.blackAlpha20}, 0px 6px 10px 0px ${colors.blackAlpha15}, 0px 1px 18px 0px ${colors.blackAlpha10}`,
        '&:hover': {
            backgroundColor: colors.orange,
            opacity: 0.8,
        },
        [theme.breakpoints.down('sm')]: {
            height: 40,
            width: 40,
            minWidth: 40,
        },
    },
    icon: {
        flexShrink: 0,
        fontSize: '18px',
    },
}));

export default function Fab(props) {
    const classes = useStyles(props);
    const createLabel = useCreateLabel();

    const isExcel = props.iconAddExcel === 'excel';

    // Tooltip title resolution:
    //   - Excel buttons: use props.label if provided, else empty (outer Tooltip handles it)
    //   - Create buttons: use props.label if explicitly provided (string, even empty);
    //     fall back to the route-derived "Create <PageName>" label otherwise.
    const tooltipTitle = isExcel
        ? (props.label || '')
        : (props.label !== undefined ? props.label : createLabel);

    const getIcon = (type) => {
        if (props.icon) {
            return props.icon;
        }
        switch (type) {
            case 'excel':
                return <GetAppIcon className={classes.icon} />;
            case 'add':
                return <AddIcon className={classes.icon} />;
            default:
                return <AddIcon className={classes.icon} />;
        }
    };

    return (
        <Tooltip
            title={tooltipTitle}
            arrow
            placement="top"
        >
            <FabButton
                {...props}
                className={classes.root}
                disabled={props.disabled}
                data-testid={props.testId || `fab-${props.type || 'default'}`}
            >
                {getIcon(props.iconAddExcel)}
            </FabButton>
        </Tooltip>
    );
}
